/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFileCross: {
  name: 'file-cross';
  data: string;
} = {
  name: 'file-cross',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 20V4a1 1 0 0 1 1-1h6.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V20a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 4v4a1 1 0 0 0 1 1h4M14 13l-4 4M10 13l4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
};
